/*
 * ET - PDP Features (sections/et-pdp-features.liquid)
 * <et-pdp-features-bar>: the Progress card bar. With data-animate="true" it starts empty (--armed) and fills to its
 * value once half of it is in view (--in-view), then stops observing. Skipped for prefers-reduced-motion and without
 * IntersectionObserver, so the bar just shows its value (the CSS default). A custom element re-runs on every connect,
 * so theme editor re-renders (shopify:section:load) set a fresh bar up and removed bars disconnect their observer.
 * Loaded by the section only when a Progress card animates its bar.
 */
(function () {
  'use strict';

  if (!window.customElements || window.customElements.get('et-pdp-features-bar')) return;

  const ARMED_CLASS = 'et-pdp-features__bar--armed';
  const IN_VIEW_CLASS = 'et-pdp-features__bar--in-view';
  const reducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  class EtPdpFeaturesBar extends HTMLElement {
    connectedCallback() {
      this.classList.remove(ARMED_CLASS, IN_VIEW_CLASS);

      if (this.dataset.animate !== 'true') return;
      if (reducedMotion && reducedMotion.matches) return;
      if (!('IntersectionObserver' in window)) return;

      this.classList.add(ARMED_CLASS);
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.classList.add(IN_VIEW_CLASS);
          this.stopObserving();
        },
        { threshold: 0.5 }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.stopObserving();
    }

    stopObserving() {
      if (!this.observer) return;
      this.observer.disconnect();
      this.observer = null;
    }
  }

  customElements.define('et-pdp-features-bar', EtPdpFeaturesBar);
})();
